application.register("wishlist_cart", class extends Stimulus.Controller {
    saveKompletVariant(e) {
        importScript(cdnjs.jquery, () => {
            let inputName = `kompletItem[${e.target.getAttribute('data-komplet-key')}]`
            let selector = `[name='${inputName}']`
            $(selector).val(e.target.value)
        })
    }
});
